// extracted by mini-css-extract-plugin
export default {"root":"hCCki","tag":"Imprx","logo":"GzKe5","dropdowns":"KHFQ2","dropdown":"J5SO1"};